import User from "../../../app/model/domain/user"
import UserService from "../../../app/services/user/user.service"
import AuthService from "../../../app/services/auth/auth.service"
import GoogleFormService from "../../../app/services/google-forms/google-form.service"
import StudentCacheService from "../../../app/services/student-cache/student-cache.service"

export class DeleteAccountService {
  static readonly AssignmentsWorkedOnThreshold = 5

  readonly deleteOptions: string[] = [
    "Wrong Account Type",
    "Pro Expired",
    "Don't Like Classkick",
  ]

  constructor(
    private UserService: UserService,
    private AuthService: AuthService,
    private GoogleFormService: GoogleFormService,
    private StudentCacheService: StudentCacheService,
  ) {
    "ngInject"
  }

  getDeleteOptions(): string[] {
    return this.deleteOptions
  }

  isTeacher(): boolean {
    return Boolean(this.AuthService.authData?.isTeacher)
  }

  autocompleteFilter(search: string | null, array: string[]): string[] {
    if (!search) {
      return array
    }
    return array.filter((value) =>
      value.toLowerCase().includes(search.toLowerCase()),
    )
  }

  logDeleteReason(user: User, reason: string | null): void {
    if (reason && this.GoogleFormService) {
      this.GoogleFormService.sendDeleteReason(user, reason)
    }
  }

  async deleteAccount(user: User, reason: string | null): Promise<void> {
    this.logDeleteReason(user, reason)
    await this.UserService.delete(user.id)
  }

  signOut(): void {
    this.AuthService.signOut()
  }

  deleteAccountDialog(
    user: User,
  ): Promise<"delete" | "email-support"> | "delete" {
    if (!user) {
      throw new Error("User not available")
    }
    if (this.isTeacher()) {
      return "delete"
    }
    const promise = this.StudentCacheService.getUserAssignmentsAndWorks(true)
    return promise.then(({ works }) => {
      const worksStarted = this._worksStarted(works)
      if (worksStarted > DeleteAccountService.AssignmentsWorkedOnThreshold) {
        return "email-support" as const
      }
      return "delete" as const
    })
  }

  private _worksStarted(works: Map<string, any>): number {
    return Array.from(works.values()).filter((work) => work.hasStarted).length
  }
}
